import { useState, useRef, useContext, useEffect } from "react";
import Loader from "../Loader";
import AuthContext from "../../Contexts/Auth/AuthContext";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const ConfigurationsCreateUpdate = () => {
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const tokenRef = useRef();

  const defaultValidationState = {
    clientId: { invalid: false, message: "Please enter client id" },
    clientSecret: { invalid: false, message: "Please enter client secret" },
    token: { invalid: false, message: "Please enter token" },
  };

  const [validateValues, setValidateValues] = useState(
    defaultValidationState
  );

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [configurationValues, setConfigurationValues] = useState({
    clientId: '',
    clientSecret: '',
    token: '',
    id: '',
  });

  const [passwordFields, setPasswordFields] = useState({
    field: "password", icon: "fa fa-eye",
  });

  useEffect(() => {
    const fetchData = async () => {
        const response = await fetch(
            process.env.REACT_APP_EXPRESS_URL + "/configurations",
            {
                method: "GET",
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authContext.token,
                },
            }
        );

        if(!response.ok) {
            if(response.status === 401) {
                localStorage.removeItem('linkedin-scheduler-token');
                return window.location.href="/login";
            }
            const error = await response.json();

            setResponse((prevState) => {
                return { success: false, message: error.message };
            });
            return;
        } 

        const data = await response.json();

        // console.log(data.data.client_id,data.data.client_secret,data.data.token)
        setConfigurationValues({
            clientId: data?.data?.client_id,
            clientSecret: data?.data?.client_secret,
            token: data?.data?.token,
            id: data?.data?._id
        })
    }

    fetchData();
  }, []);

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {
    setValidateValues(defaultValidationState);
    event.preventDefault();

    const clientId = configurationValues.clientId;
    const clientSecret = configurationValues.clientSecret;
    const token = configurationValues.token;

    let isValid = true;

    if (isEmpty(clientId)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          clientId: { ...prevState.clientId, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(clientSecret)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          clientSecret: { ...prevState.clientSecret, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(token)) {
      setValidateValues((prevState) => {
        return { ...prevState, token: { ...prevState.token, invalid: true } };
      });
      isValid = false;
    }

    const formData = {};

    if (isValid) {
      setIsLoading(true);

      formData.clientId = clientId;
      formData.clientSecret = clientSecret;
      formData.token = token;
      if(configurationValues.id) {
        formData.id = configurationValues.id;
      }
      Object.freeze(formData);

      console.table(formData);

        try {
        const response = await fetch(
          process.env.REACT_APP_EXPRESS_URL + "/configurations",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + authContext.token,
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          if(response.status === 401) {
            localStorage.removeItem('linkedin-scheduler-token');
            return window.location.href="/login";
          }
          const error = await response.json();

          if (response.status === 422) {
            console.table(error.errors);
            for (const key of error.errors) {
              setValidateValues((prevState) => {
                return {
                  ...prevState,
                  [key.path]: { message: [key.msg], invalid: true },
                };
              });
            }
          } else {
            setResponse((prevState) => {
              return { success: false, message: error.message };
            });
          }

          return;
        }
        const data = await response.json();

        setResponse((prevState) => {
          return { success: true, message: data.message };
        });

        
      } catch (error) {
        setResponse((prevState) => ({
          success: false,
          message: "Something went wrong. Please try again.",
        }));
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setResponse(null);
        }, 3000);
      }
    }
  };

  const changeHandler = (event) => {
    setConfigurationValues((prevState) => {
      return { ...prevState, [event.target.id]: event.target.value };
    });
  };

  const updatePasswordFieldHandler = (event) => {
    setPasswordFields((prevState) => {
      return {
        field : prevState.field === 'password' ? 'text' : 'password',
        icon : prevState.field === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'
      }
    })
  }

  const closeAlert = () => setResponse(null);

    return (
      <div className="p-6 pt-26 text-white overflow-hidden min-h-screen">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
          <h4 className="text-l font-semibold">Configuration</h4>
          <div className="text-l text-gray-400 md:mt-0">
            <button type="button" className="text-blue" onClick={() => navigate("/panel/dashboard")}>Home</button>
            <span> / Configuration</span>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 shadow-md mx-auto space-y-6 w-full">
          {isLoading && <Loader />}
          {response && (
            <div
              className={`relative px-4 py-3 rounded-lg text-sm border transition-opacity duration-500 ease-in-out ${
                response.success
                  ? 'bg-green-100 text-green-600 border-green-300'
                  : 'bg-rose-100 text-rose-600 border-rose-300'
              }`}
            >
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-xl text-gray-500 hover:text-gray-700"
                onClick={closeAlert}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
          )}

          <form className="space-y-4" onSubmit={submitHandler}>
            <div>
              <label className="block mb-1 text-sm text-gray-300 flex items-center gap-2">
                Client ID
                <div className="relative group inline-block">
                  <i className="fas fa-question-circle text-gray-400 hover:text-white ml-1" style={{ cursor: 'pointer' }}></i>

                  <div
                    className="absolute left-full top-1/2 ml-2 transform -translate-y-1/2 
                              opacity-0 group-hover:opacity-100 
                              transition-opacity duration-200 
                              bg-gray-700 text-white text-xs px-3 py-1 rounded shadow-lg 
                              z-10 whitespace-nowrap 
                              pointer-events-none group-hover:pointer-events-auto"
                  >
                    Enter Client ID from <br /> the developer portal.
                  </div>
                </div>
              </label> 
              <input
                type="text"
                className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  validateValues.clientId.invalid ? 'border-rose-500' : ''
                }`}
                id="clientId"
                placeholder="Enter client id"
                value={configurationValues.clientId}
                onChange={changeHandler}
              />
              {validateValues.clientId.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.clientId.message}</span>
              )}
            </div>

            <div>
              <label className="block mb-1 text-sm text-gray-300 flex items-center gap-2">
                Client Secret
                <div className="relative group inline-block">
                  <i className="fas fa-question-circle text-gray-400 hover:text-white ml-1" style={{ cursor: 'pointer' }}></i>

                  <div
                    className="absolute left-full top-1/2 ml-2 transform -translate-y-1/2 
                              opacity-0 group-hover:opacity-100 
                              transition-opacity duration-200 
                              bg-gray-700 text-white text-xs px-3 py-1 rounded shadow-lg 
                              z-10 whitespace-nowrap 
                              pointer-events-none group-hover:pointer-events-auto"
                  >
                    Enter Client Secret from <br /> the developer portal.
                  </div>
                </div>
              </label>
              <input
                type="text"
                className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  validateValues.clientSecret.invalid ? 'border-rose-500' : ''
                }`}
                id="clientSecret"
                placeholder="Enter client secret"
                value={configurationValues.clientSecret}
                onChange={changeHandler}
              />
              {validateValues.clientSecret.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.clientSecret.message}</span>
              )}
            </div>

            <div>
              <label className="block mb-1 text-sm text-gray-300 flex items-center gap-2">
                Token 
                <div className="relative group inline-block">
                  <i className="fas fa-question-circle text-gray-400 hover:text-white ml-1" style={{ cursor: 'pointer' }}></i>
                  <div
                    className="absolute left-full top-1/2 ml-2 transform -translate-y-1/2 
                              opacity-0 group-hover:opacity-100 
                              transition-opacity duration-200 
                              bg-gray-700 text-white text-xs px-3 py-1 rounded shadow-lg 
                              z-10 whitespace-nowrap 
                              pointer-events-none group-hover:pointer-events-auto"
                  >
                    Enter token generated using Open <br/> Auth 2.0 toolkit in the developer portal.
                  </div>
                </div>
              </label>
              <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                <input
                  type={passwordFields.field}
                  id="token"
                  className={`w-full px-4 py-2 bg-gray-700 text-white focus:outline-none rounded-l-lg`}
                  placeholder="Enter token"
                  onChange={changeHandler}
                  ref={tokenRef}
                  value={configurationValues.token}
                />
                <div
                  className="px-3 text-gray-400 cursor-pointer"
                  onClick={updatePasswordFieldHandler}
                >
                  <i className={passwordFields.icon}></i>
                </div>
              </div>
              {validateValues.token.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.token.message}</span>
              )}
            </div>

            <button
              type="submit"
              id="userSave"
              className="w-25 mt-2 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Save Configuration
            </button>
          </form>
        </div>
      </div>
    );
};

export default ConfigurationsCreateUpdate;
